import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CheckPhoneVerify, PhoneVerify } from "./CheckPhoneVerifyAPI";

// Async thunk to send phone
export const CheckPhoneVerifyAsync = createAsyncThunk(
    "phone/check",
    async (mobile, { rejectWithValue }) => {
        try {
            const data = await CheckPhoneVerify(mobile); // Already parsed JSON

            //   console.log("response slice", data);

            return data; // No need to re-parse JSON
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const PhoneVerifyAsync = createAsyncThunk(
    "phone/verify",
    async (phone, { rejectWithValue }) => {
        try {
            const data = await PhoneVerify(phone); // Already parsed JSON

            //   console.log("response slice", data);

            return data; // No need to re-parse JSON
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const phoneSlice = createSlice({
    name: "phone",
    initialState: {
        loading: false,
        success: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(CheckPhoneVerifyAsync.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })
            .addCase(CheckPhoneVerifyAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(CheckPhoneVerifyAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(PhoneVerifyAsync.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })
            .addCase(PhoneVerifyAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(PhoneVerifyAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default phoneSlice.reducer;